// Get Customer Data
let customerCartEmail = document
  .querySelector(".cart-page")
  .getAttribute("data-email");

let customerCartMobile = document
  .querySelector(".cart-page")
  .getAttribute("data-mobile");

let cartBody = {};
const customer_id = ShopifyAnalytics.meta.page.customerId
  ? ShopifyAnalytics.meta.page.customerId
  : "";
let data = {};
data.customer_id = customer_id;

if (customerCartMobile) {
  cartBody.identifier = "mobile";
  cartBody.value = customerCartMobile;
} else if (customerCartEmail) {
  cartBody.identifier = "email";
  cartBody.value = customerCartEmail;
}

function loyaltyPoints(cartBody) {
  // -------------------------------
  // 🔐 AES Encryption + Token Setup
  // -------------------------------
  const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

  function encryptData(data) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  }

  function generateToken(reqBody, callback) {
    const encryptedPayload = encryptData(reqBody);
    $.ajax({
      url: "https://apis.arvindfashions.com/generate-token",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({ payload: encryptedPayload }),
      success: function (tokenResponse) {
        const apiToken = tokenResponse?.token;
        if (apiToken) {
          callback(apiToken);
        } else {
          console.error("❌ No token received from token API.");
        }
      },
      error: function (xhr, status, error) {
        console.error("❌ Error generating token:", error);
      },
    });
  }

  // -------------------------------
  // 💎 Secure Loyalty Points API
  // -------------------------------
  generateToken(cartBody, function (apiToken) {
    $.ajax({
      url: "https://apis.arvindfashions.com/api/customer/getdetails",
      method: "POST",
      contentType: "application/json",
      headers: { Authorization: `Bearer ${apiToken}` },
      dataType: "json",
      success: function (cartpoint) {
        if (!cartpoint?.data?.pointsSummary) {
          console.warn("⚠️ No points summary found in response.");
          return;
        }

        const pointsSummary = cartpoint.data.pointsSummary;

        // Assign loyalty data
        data.programId = pointsSummary.programId;
        data.loyaltyPoints = pointsSummary.loyaltyPoints;

        // Format and render points
        const roundedNumber = Math.round(pointsSummary.loyaltyPoints);
        const formattedNumber = roundedNumber.toLocaleString();

        console.log(formattedNumber, "formattedNumber");

        const pointEl = document.querySelector(
          ".main_loyality span#cstm_available_point",
        );
        const validationEl = document.querySelector(
          ".main_loyality #pointValidation",
        );

        if (pointEl) pointEl.textContent = formattedNumber;
        if (validationEl) validationEl.textContent = roundedNumber;
      },
      error: function () {
        console.error("❌ Error retrieving loyalty points (getdetails)");
        // Don't touch spinner here
      },
    });
  });
}

// cart discount remove function

function cart_discount_remove() {
  const DEBUG_MODE = true; // set false in production

  // Reset redeem spinner if visible
  $("#redeemBtn").find("svg").hide();
  $("#redeemBtn").find(".btntext").show();
  $("#redeemBtn").prop("disabled", false);

  const removeBtn = document.getElementById("removeBtn");
  const redeemBtn = document.getElementById("redeemBtn");
  const inputField = document.getElementById("input_field_loyalty");

  // Show loader
  removeBtn.querySelector(".btntext").style.display = "none";
  removeBtn.querySelector("svg").style.display = "inline-block";

  const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

  // -------------------------------
  // AES encryption helper
  // -------------------------------
  function encryptData(data) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  }

  // -------------------------------
  // Token generator
  // -------------------------------
  function generateToken(cartBody) {
    return new Promise((resolve, reject) => {
      const reqBody = {
        identifier: cartBody.identifier,
        value: cartBody.value,
      };
      const encryptedPayload = encryptData(reqBody);

      if (DEBUG_MODE) {
        console.log("🟢 Token request payload (before encryption):", reqBody);
        console.log("🟣 Token request encrypted payload:", encryptedPayload);
      }

      $.ajax({
        url: "https://apis.arvindfashions.com/generate-token",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({ payload: encryptedPayload }),
        success: function (res) {
          if (DEBUG_MODE) console.log("🟢 Token API response:", res);
          if (res?.token) resolve(res.token);
          else reject("No token received");
        },
        error: function (xhr, status, error) {
          console.error(
            "❌ Token generation failed:",
            xhr.responseText || error,
          );
          reject(error);
        },
      });
    });
  }

  // -------------------------------
  // Main flow
  // -------------------------------
  fetch("/cart.js")
    .then((res) => res.json())
    .then(async (res) => {
      // ✅ Fix missing fields before encryption
      if (!res.items_subtotal_price && res.items_subtotal_price !== 0) {
        res.items_subtotal_price = res.original_total_price || 0;
      }

      if (res.cart_level_discount_applications?.length) {
        res.cart_level_discount_applications =
          res.cart_level_discount_applications.map((app) => ({
            ...app,
            created_at: app.created_at || new Date().toISOString(),
          }));
      } else {
        // Shopify sometimes stops reporting an already-applied loyalty
        // discount as a cart-level application (e.g. it became inapplicable
        // after the cart changed), which would otherwise make the reverse
        // API reject the request as it can't identify which discount to
        // reverse. Fall back to the code we stored on redemption so the
        // request still carries it.
        const fallbackDiscountCode = $("#loyaltydiscountcode").val();
        if (fallbackDiscountCode) {
          res.cart_level_discount_applications = [
            {
              title: fallbackDiscountCode,
              created_at: new Date().toISOString(),
            },
          ];
        }
      }

      const requestData = {
        ...res,
        customer_info: {
          email: customerCartEmail || "",
          phone: customerCartMobile || "",
        },
        customer_id: customer_id || "",
      };

      if (DEBUG_MODE)
        console.log(
          "🟢 manageReversePoints requestData (before encryption):",
          requestData,
        );

      // 🔑 Generate token
      const apiToken = await generateToken(cartBody);
      if (DEBUG_MODE) console.log("🔐 Generated API Token:", apiToken);

      // 🔒 Encrypt final payload
      const encryptedPayload = encryptData(requestData);
      if (DEBUG_MODE)
        console.log(
          "🟣 Encrypted manageReversePoints payload:",
          encryptedPayload,
        );

      // 🧾 Final request summary
      if (DEBUG_MODE) {
        console.log("📤 Final API Request to manageReversePoints:", {
          url: "https://apis.arvindfashions.com/api/points/manageReversePoints",
          headers: { Authorization: `Bearer ${apiToken}` },
          body: { payload: encryptedPayload },
        });
      }

      // 🔥 API Call
      const apiResponse = await fetch(
        "https://apis.arvindfashions.com/api/points/manageReversePoints",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiToken}`,
          },
          body: JSON.stringify({ payload: encryptedPayload }),
        },
      );

      if (DEBUG_MODE)
        console.log("📥 API Response status:", apiResponse.status);

      if (apiResponse.ok) {
        // ✅ On success
        await fetch(`/checkout?discount=''`);

        fetch("/cart/update.js", { method: "POST" })
          .then((res) => res.json())
          .then(() => {
            fetch("/cart?view=ajax")
              .then((ress) => ress.text())
              .then((ress) => {
                const result = ress
                  .replaceAll("<template", "<div")
                  .replaceAll("template>", "div>");
                const element = document.createElement("div");
                element.insertAdjacentHTML("beforeend", result);

                const finalDetails = element.querySelector(
                  ".ajax-cart__final-details",
                );
                if (finalDetails) {
                  document.querySelector(
                    "section .ajax-cart__final-details",
                  ).innerHTML = finalDetails.innerHTML;
                }

                const cartItems = element.querySelector(
                  ".ajax-cart__cart-items",
                );
                if (cartItems) {
                  document.querySelector(".ajax-cart__cart-items").innerHTML =
                    cartItems.innerHTML;
                }

                if (
                  typeof Shopify?.theme?.ajaxCart?.cartEvents === "function"
                ) {
                  Shopify.theme.ajaxCart.cartEvents(window.cartConfig || {});
                }

                fetch("/cart.js")
                  .then((r) => r.json())
                  .then((cart) => checkCartThreshold(cart));
              });

            // Swap buttons and reset fields
            removeBtn.style.display = "none";
            redeemBtn.style.display = "block";
            redeemBtn.disabled = true;

            $("#appliedPoints").val(0);

            inputField.removeAttribute("disabled");
            inputField.value = "";

            // Reset loader
            removeBtn.querySelector("svg").style.display = "none";
            removeBtn.querySelector(".btntext").style.display = "block";

            // Show success message
            $(".successmessage").hide();
            $("#pointremovedmsg").show();
            document.getElementById("input_field_coupon").disabled = false;

            loyaltyPoints(cartBody);
            setTimeout(() => $("#pointremovedmsg").hide(), 4000);
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
            removeBtn.querySelector("svg").style.display = "none";
            removeBtn.querySelector(".btntext").style.display = "block";
          });
      } else {
        let apiErrorBody = "";
        try {
          apiErrorBody = await apiResponse.clone().text();
        } catch (e) {}
        console.error("❌ API Error:", apiResponse.status, apiErrorBody);
        removeBtn.querySelector("svg").style.display = "none";
        removeBtn.querySelector(".btntext").style.display = "block";
        showRemovePointsError();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      removeBtn.querySelector("svg").style.display = "none";
      removeBtn.querySelector(".btntext").style.display = "block";
      showRemovePointsError();
    });
}

// Non-invasive error banner for a failed points removal.
// Leaves all button/input states untouched so the customer can simply retry.
function showRemovePointsError(
  msg = "Could not remove points right now. Please try again.",
) {
  const $err = $("#error-messagecart");
  if (!$err.length) return;
  $err.text(msg).show();
  clearTimeout(showRemovePointsError._t);
  showRemovePointsError._t = setTimeout(() => $err.hide(), 5000);
}

function voucher_remove() {
  const removeBtn = document.getElementById("removeCoupon");
  const redeemBtn = document.getElementById("coupon_btn_title");
  const inputField = document.getElementById("input_field_coupon");

  // Loader state
  removeBtn.querySelector(".btntext").style.display = "none";
  removeBtn.querySelector("svg").style.display = "inline-block";

  // -------------------------------
  // 🔐 AES Encryption + Token Setup
  // -------------------------------
  const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

  function encryptData(payload) {
    return CryptoJS.AES.encrypt(JSON.stringify(payload), secretKey).toString();
  }

  function generateToken(reqBody) {
    return new Promise((resolve, reject) => {
      const encryptedPayload = encryptData(reqBody);
      $.ajax({
        url: "https://apis.arvindfashions.com/generate-token",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({ payload: encryptedPayload }),
        success: function (res) {
          if (res?.token) resolve(res.token);
          else reject("No token received");
        },
        error: function (xhr, status, error) {
          console.error(
            "❌ Token generation failed:",
            xhr.responseText || error,
          );
          reject(error);
        },
      });
    });
  }

  // -------------------------------
  // 🚀 Main Secure Flow
  // -------------------------------
  fetch("/cart.js")
    .then((res) => res.json())
    .then(async () => {
      try {
        const requestData = { customer_id: customer_id };

        // 🔑 Generate secure token using cartBody
        const apiToken = await generateToken(cartBody);

        // 🔒 Encrypt payload
        const encryptedPayload = encryptData(requestData);

        // 🧾 Call reverseCoupon API securely
        const apiResponse = await fetch(
          "https://apis.arvindfashions.com/api/points/reverseCoupon",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${apiToken}`,
            },
            body: JSON.stringify({ payload: encryptedPayload }),
          },
        );

        if (apiResponse.ok) {
          await fetch(`/checkout?discount=''`);

          // Update Shopify cart after successful removal
          fetch("/cart/update.js", { method: "POST" })
            .then((res) => res.json())
            .then(() => {
              fetch("/cart?view=ajax")
                .then((ress) => ress.text())
                .then((ress) => {
                  const result = ress
                    .replaceAll("<template", "<div")
                    .replaceAll("template>", "div>");
                  const element = document.createElement("div");
                  element.insertAdjacentHTML("beforeend", result);

                  // Update cart sections
                  const finalDetails = element.querySelector(
                    ".ajax-cart__final-details",
                  );
                  if (finalDetails) {
                    document.querySelector(
                      "section .ajax-cart__final-details",
                    ).innerHTML = finalDetails.innerHTML;
                  }

                  const cartItems = element.querySelector(
                    ".ajax-cart__cart-items",
                  );
                  if (cartItems) {
                    document.querySelector(".ajax-cart__cart-items").innerHTML =
                      cartItems.innerHTML;
                  }

                  // Reinitialize AJAX cart events
                  if (
                    typeof Shopify?.theme?.ajaxCart?.cartEvents === "function"
                  ) {
                    Shopify.theme.ajaxCart.cartEvents(window.cartConfig || {});
                  }

                  // Refresh threshold logic
                  fetch("/cart.js")
                    .then((r) => r.json())
                    .then((cart) => checkCartThreshold(cart));
                });

              // Reset UI
              removeBtn.style.display = "none";
              redeemBtn.style.display = "block";
              redeemBtn.disabled = true;
              inputField.removeAttribute("disabled");
              inputField.value = "";

              removeBtn.querySelector("svg").style.display = "none";
              removeBtn.querySelector(".btntext").style.display = "block";

              // Show success message
              $("#vouchermovedmsg").show();
              document.getElementById("input_field_loyalty").disabled = false;
              $("#cstm_coupon_secc").hide();
              setTimeout(() => {
                $("#vouchermovedmsg").hide();
              }, 4000);

              loyaltyPoints(cartBody);
            })
            .catch((error) => {
              console.error("❌ Error updating cart:", error);
              removeBtn.querySelector("svg").style.display = "none";
              removeBtn.querySelector(".btntext").style.display = "block";
            });
        } else {
          console.error("❌ reverseCoupon API failed:", apiResponse.status);
          removeBtn.querySelector("svg").style.display = "none";
          removeBtn.querySelector(".btntext").style.display = "block";
        }
      } catch (error) {
        console.error("❌ Error in voucher_remove flow:", error);
        removeBtn.querySelector("svg").style.display = "none";
        removeBtn.querySelector(".btntext").style.display = "block";
      }
    })
    .catch((error) => {
      console.error("❌ Error fetching cart:", error);
      removeBtn.querySelector("svg").style.display = "none";
      removeBtn.querySelector(".btntext").style.display = "block";
    });
}

$(document).ready(function () {
  // 1. Listen for Quantity +/- button clicks
  $(document).on(
    "click",
    ".ajax-cart__qty-control, .qty-btn, .cart__qty-button",
    function () {
      triggerServiceabilityRefresh();
    },
  );

  // 2. Listen for Variant changes within the cart (if applicable)
  $(document).on(
    "change",
    'select[name="id"], .cart__product-option select',
    function () {
      triggerServiceabilityRefresh();
    },
  );

  // 3. Shopify specific event listeners (common in many themes)
  document.addEventListener("cart:updated", triggerServiceabilityRefresh);
  document.addEventListener("cart:refresh", triggerServiceabilityRefresh);
  $(document).on("ajaxCart.afterCartUpdate", triggerServiceabilityRefresh);
});

$(document).ready(function () {
  if ($("#loyaltypoints").length > 0) {
    let loyaltypoints = $("#loyaltypoints").val();
    if (loyaltypoints) {
      $("#input_field_loyalty").val(loyaltypoints);
      if ($("#loyaltydiscountcode").length > 0) {
        let discountcode = $("#loyaltydiscountcode").val();
        // $('#input_field_coupon').attr('disabled',true);
        discountUpdate("loyalty", discountcode);
      }
    }
    if ($("#voucherdiscountcode").length > 0) {
      let discountcode = $("#voucherdiscountcode").val();
      let codeToShow = discountcode.includes("USPA-")
        ? discountcode.split("USPA-")[1]
        : discountcode;
      $("#input_field_coupon").val(codeToShow);
      // $('#input_field_loyalty').attr('disabled', true);
      discountUpdate("voucher", discountcode);
    }
  }

  loyaltyPoints(cartBody);

  function isPointRedeemable(cartBody, data) {
    // -------------------------------
    // 🔐 AES Encryption + Token Setup
    // -------------------------------
    const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

    // AES Encrypt
    function encryptData(payload) {
      return CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        secretKey,
      ).toString();
    }

    // Generate token API
    function generateToken(reqBody) {
      return new Promise((resolve, reject) => {
        const encryptedPayload = encryptData(reqBody);

        $.ajax({
          url: "https://apis.arvindfashions.com/generate-token",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({ payload: encryptedPayload }),
          success: function (res) {
            if (res?.token) {
              resolve(res.token);
            } else {
              console.error("No token received");
              reject("No token");
            }
          },
          error: function (xhr, status, error) {
            console.error("Token generation failed:", error);
            reject("Token generation failed");
          },
        });
      });
    }

    // --------------------------------
    // 🔁 Main Redeemable Points Flow
    // --------------------------------
    generateToken(cartBody)
      .then((apiToken) => {
        // Construct redeem check data
        const redeemCheckBody = {
          program_id: data.programId,
          points: data.points,
          mobile: cartBody.value,
        };

        // Encrypt payload
        const encryptedPayload = encryptData(redeemCheckBody);

        // Final secured URL (no payload in URL)
        const url =
          "https://apis.arvindfashions.com/api/points/isPointRedeemable";

        // POST request with Authorization header
        $.ajax({
          url: url,
          method: "POST",
          contentType: "application/json",
          headers: { Authorization: `Bearer ${apiToken}` },
          data: JSON.stringify({ payload: encryptedPayload }),
          success: function (redeempoint) {
            const is_redeemable =
              redeempoint?.data?.response?.points?.redeemable?.is_redeemable ||
              false;

            if (is_redeemable === "true" || is_redeemable === true) {
              data.points_value =
                redeempoint.data.response.points.redeemable.points_redeem_value;

              // Proceed with next step
              manageRewardPoints(cartBody, data);
            } else {
              $("#errormessage")
                .html("Entered points exceed your available balance.")
                .show();
              setTimeout(() => {
                $("#errormessage").fadeOut(300);
              }, 5000);
              $(".successmessage").hide();

              const $redeem = $("#redeemBtn");
              $redeem.find("svg").hide();
              $redeem.find(".btntext").show();
              $redeem.prop("disabled", false);
            }
          },
          error: function (xhr, status, error) {
            console.error("Error in redeemable check:", error);
            const $redeem = $("#redeemBtn");
            $redeem.find("svg").hide();
            $redeem.find(".btntext").show();
            $redeem.prop("disabled", false);
          },
        });
      })
      .catch((err) => {
        console.error("Token Error:", err);
        const $redeem = $("#redeemBtn");
        $redeem.find("svg").hide();
        $redeem.find(".btntext").show();
        $redeem.prop("disabled", false);
      });
  }

  function generateRandomCode() {
    const timestamp = Date.now().toString(36);
    const randomNum = Math.random().toString(36).substring(2, 10);
    var code = (timestamp + randomNum).substring(0, 8);
    code = "RCP" + code;
    return code.toUpperCase();
  }

  function manageRewardPoints(cartBody, data) {
    // -------------------------------
    // 🔐 AES Encryption + Token Setup
    // -------------------------------
    const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

    function encryptData(payload) {
      return CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        secretKey,
      ).toString();
    }

    function generateToken(reqBody) {
      return new Promise((resolve, reject) => {
        const encryptedPayload = encryptData(reqBody);
        $.ajax({
          url: "https://apis.arvindfashions.com/generate-token",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({ payload: encryptedPayload }),
          success: function (res) {
            if (res?.token) resolve(res.token);
            else reject("No token received");
          },
          error: function (xhr, status, error) {
            console.error(
              "❌ Token generation failed:",
              xhr.responseText || error,
            );
            reject(error);
          },
        });
      });
    }

    // -------------------------------
    // 🧠 Prepare Request Data
    // -------------------------------
    const requestData = {
      reward_value: data.points,
      reward_price: data.points_value,
      customer_id: data.customer_id,
      value: cartBody.value,
    };

    // -------------------------------
    // 🚀 Main Secure Flow
    // -------------------------------
    (async function () {
      try {
        // Step 1: Generate API token
        const apiToken = await generateToken(cartBody);

        // Step 2: Encrypt request data
        const encryptedPayload = encryptData(requestData);

        // Step 3: Call manageRewardPoints securely
        const manageResponse = await fetch(
          "https://apis.arvindfashions.com/api/manageRewardPoints",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${apiToken}`,
            },
            body: JSON.stringify({ payload: encryptedPayload }),
          },
        );

        const manageRewardPoints = await manageResponse.json();
        if (!manageResponse.ok || !manageRewardPoints.status) {
          throw new Error("Reward points API failed");
        }

        // ✅ Continue only if successful
        loyaltyPoints(cartBody);

        // -------------------------------
        // 🎟️ Prepare voucher create data
        // -------------------------------
        const remdemedcode = generateRandomCode();
        let current_time = new Date();
        let valid_till = new Date(
          current_time.getTime() + 20 * 24 * 60 * 60 * 1000,
        );
        current_time = current_time.toISOString();
        valid_till = valid_till.toISOString();

        const redeem_discount_data = {
          code: remdemedcode,
          title: `CPL_${remdemedcode}`,
          value: data.points_value,
          type: "fixed",
          customer_id: data.customer_id,
          createdDate: current_time,
          validTill: valid_till,
        };

        // Step 4: Encrypt voucher payload
        const encryptedVoucherPayload = encryptData(redeem_discount_data);

        // Step 5: Call voucher_create securely
        const voucherResponse = await fetch(
          "https://apis.arvindfashions.com/api/voucher_create",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${apiToken}`,
            },
            body: JSON.stringify({ payload: encryptedVoucherPayload }),
          },
        );

        if (voucherResponse.ok) {
          discountUpdate("loyalty", redeem_discount_data.code);
        } else {
          console.error("❌ Voucher create failed");
          $("#errormessage").html("Failed to create voucher").show();
          const $redeem = $("#redeemBtn");
          $redeem.find("svg").hide();
          $redeem.find(".btntext").show();
          $redeem.prop("disabled", false);
        }
      } catch (error) {
        console.error("❌ manageRewardPoints error:", error);
        $("#errormessage")
          .html("Something went wrong, please try again")
          .show();
        const $redeem = $("#redeemBtn");
        $redeem.find("svg").hide();
        $redeem.find(".btntext").show();
        $redeem.prop("disabled", false);
      }
    })();
  }

  // START SPINNER ON CLICK (no timeouts)
  $(document).on("click", ".loyalty_btn_field", function () {
    const btn = $(this);
    let loyaltypoint =
      parseInt($(".available_point #pointValidation").text(), 10) || 0;
    let input_loyalty = parseInt($("#input_field_loyalty").val(), 10) || 0;
    let voucher_code = $("#input_field_coupon").val();

    // 🛑 Prevent applying points if voucher is already applied
    if ($("#removeCoupon").is(":visible")) {
      showApplyConflictError("points");
      return;
    }

    data.points = input_loyalty;

    // Show spinner & lock button until final success/error
    btn.prop("disabled", true);
    btn.find(".btntext").hide();
    btn.find("svg").show();
    $("#errormessage").hide();

    isPointRedeemable(cartBody, data);
  });

  /* voucher code */
  $("input#input_field_coupon").on("input", function () {
    var inputValue = $(this).val().trim();
    $(".coupon_btn_field").prop("disabled", inputValue === "");
  });

  $("body").on("click", "#coupon_btn_title", async function () {
    // 🛑 Prevent applying voucher if points are already applied
    if ($("#removeBtn").is(":visible")) {
      showApplyConflictError("voucher");
      return;
    }

    let avail_coupon = $("#input_field_coupon").val();
    let loyaltypoints = $("#input_field_loyalty").val();

    // -------------------------------
    // 🔐 AES + Token Setup
    // -------------------------------
    const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

    function encryptData(data) {
      return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    }

    function generateToken(cartBody) {
      return new Promise((resolve, reject) => {
        const reqBody = {
          identifier: cartBody.identifier,
          value: cartBody.value,
        };
        const encryptedPayload = encryptData(reqBody);

        $.ajax({
          url: "https://apis.arvindfashions.com/generate-token",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({ payload: encryptedPayload }),
          success: function (res) {
            if (res?.token) resolve(res.token);
            else reject("No token received");
          },
          error: function (xhr, status, error) {
            console.error(
              "❌ Token generation failed:",
              xhr.responseText || error,
            );
            reject(error);
          },
        });
      });
    }

    // -------------------------------
    // 🧠 Helper – Remove Loyalty First
    // -------------------------------
    function removeLoyaltyPoints() {
      return new Promise((resolve) => {
        if (loyaltypoints) {
          $("#removeBtn").click();
          setTimeout(() => resolve(true), 1000);
        } else {
          resolve(false);
        }
      });
    }

    try {
      await removeLoyaltyPoints();
      console.log("avail_coupon", avail_coupon);
      $("#coupon_btn_title .btntext").hide();
      $("#coupon_btn_title svg").show(300);
      $("#input_field_coupon").removeAttr("disabled");

      if (avail_coupon) {
        let voucherHistory = {
          customer_id: customer_id,
          phone: customerCartMobile,
          code: avail_coupon,
        };

        try {
          const result = await couponHistory(cartBody);
          const code_exists = result.entity.filter(
            (item) => item.code === avail_coupon,
          );

          if (code_exists.length > 0) {
            const codeData = code_exists[0];
            const type =
              codeData.couponDiscountType === "ABS" ? "fixed" : "percentage";
            const validTill_time = new Date(codeData.validTill).getTime();
            const current_time = new Date().getTime();

            if (validTill_time > current_time) {
              if (codeData.isRedeemed) {
                $("#cstm_coupon_secc").hide();
                $("#pointremovedmsg").hide();
                $("#cstm_coupon_err")
                  .show()
                  .text("This voucher has already been used.");
                $("#coupon_btn_title .btntext").show();
                $("#coupon_btn_title svg").hide();
              } else {
                // -------------------------------
                // 🔒 Secure redeemCoupon Call
                // -------------------------------
                try {
                  const apiToken = await generateToken(cartBody);
                  const encryptedPayload = encryptData(voucherHistory);

                  $.ajax({
                    url: "https://apis.arvindfashions.com/api/points/redeemCoupon",
                    method: "POST",
                    contentType: "application/json",
                    headers: { Authorization: `Bearer ${apiToken}` },
                    data: JSON.stringify({ payload: encryptedPayload }),
                    dataType: "json",
                    success: function (result) {
                      if (result.status) {
                        const discount_data = {
                          code: `USPA-${codeData.code}`,
                          title: `CPV_${codeData.code}`,
                          value: codeData.discountValue,
                          type: type,
                          customer_id: customer_id,
                          createdDate: codeData.createdDate,
                          validTill: codeData.validTill,
                        };
                        voucher_create(discount_data);
                      } else {
                        $("#cstm_coupon_secc").hide();
                        $("#pointremovedmsg").hide();
                        $("#cstm_coupon_err").show().text("Redemption failed");
                      }
                      setTimeout(() => {
                        $("#coupon_btn_title .btntext").show();
                        $("#coupon_btn_title svg").hide();
                      }, 2000);
                    },
                    error: function (xhr, status, error) {
                      console.error(
                        "Error in redeeming coupon:",
                        status,
                        error,
                      );
                      $("#cstm_coupon_secc").hide();
                      $("#pointremovedmsg").hide();
                      $("#cstm_coupon_err").show().text("Redemption failed");
                      setTimeout(() => {
                        $("#cstm_coupon_err").fadeOut(300);
                      }, 5000);
                      $("#coupon_btn_title .btntext").show();
                      $("#coupon_btn_title svg").hide();
                    },
                  });
                } catch (err) {
                  console.error("❌ Secure redeemCoupon error:", err);
                  $("#cstm_coupon_secc").hide();
                  $("#pointremovedmsg").hide();
                  $("#cstm_coupon_err")
                    .show()
                    .text("Authentication failed. Try again.");
                  $("#coupon_btn_title .btntext").show();
                  $("#coupon_btn_title svg").hide();
                }
              }
            } else {
              $("#cstm_coupon_secc").hide();
              $("#pointremovedmsg").hide();
              $("#cstm_coupon_err").show().text("This voucher has expired");
              setTimeout(() => {
                $("#cstm_coupon_err").fadeOut(300);
              }, 5000);
              $("#coupon_btn_title .btntext").show();
              $("#coupon_btn_title svg").hide();
            }
          } else {
            $("#cstm_coupon_secc").hide();
            $("#pointremovedmsg").hide();
            $("#cstm_coupon_err")
              .show()
              .text("Invalid voucher. Try a different code");
            setTimeout(() => {
              $("#cstm_coupon_err").fadeOut(300);
            }, 5000);
            $("#coupon_btn_title .btntext").show();
            $("#coupon_btn_title svg").hide();
          }
        } catch (err) {
          console.log("Error in fetching coupon history:", err);
          $("#coupon_btn_title .btntext").show();
          $("#coupon_btn_title svg").hide();
          $("#pointremovedmsg").hide();
          $("#cstm_coupon_err").show().text("Error in fetching coupon");
        }
      } else {
        $("#coupon_btn_title .btntext").show();
        $("#coupon_btn_title svg").hide();
        $("#pointremovedmsg").hide();
        $("#cstm_coupon_err").show();
      }
    } catch (error) {
      console.log("Error in removing loyalty points:", error);
    }
  });
});

function couponHistory(cartBody) {
  return new Promise((resolve, reject) => {
    // -------------------------------
    // 🔐 AES Encryption + Token Setup
    // -------------------------------
    const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

    function encryptData(data) {
      return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    }

    function generateToken(reqBody) {
      return new Promise((resolveToken, rejectToken) => {
        const encryptedPayload = encryptData(reqBody);
        $.ajax({
          url: "https://apis.arvindfashions.com/generate-token",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({ payload: encryptedPayload }),
          success: function (tokenResponse) {
            const apiToken = tokenResponse?.token;
            if (apiToken) {
              resolveToken(apiToken);
            } else {
              rejectToken(new Error("❌ No token received from token API"));
            }
          },
          error: function (xhr, status, error) {
            rejectToken(new Error("❌ Token generation failed: " + error));
          },
        });
      });
    }

    // -------------------------------
    // 🎟️ Secure Coupon History API
    // -------------------------------
    generateToken(cartBody)
      .then((apiToken) => {
        $.ajax({
          url: "https://apis.arvindfashions.com/api/customer/getCoupons",
          method: "POST",
          contentType: "application/json",
          headers: { Authorization: `Bearer ${apiToken}` },
          dataType: "json",
          success: function (couponHistory) {
            resolve(couponHistory.data);
          },
          error: function (xhr, status, error) {
            reject(new Error("❌ Failed to fetch coupon history: " + error));
          },
        });
      })
      .catch((tokenError) => {
        reject(tokenError);
      });
  });
}

function voucher_create(discount_data) {
  // -------------------------------
  // 🔐 AES Encryption + Token Setup
  // -------------------------------
  const secretKey = "3c60cd08-2eb0-4e33-a538-df4c6474ba42";

  function encryptData(payload) {
    return CryptoJS.AES.encrypt(JSON.stringify(payload), secretKey).toString();
  }

  function generateToken(reqBody) {
    return new Promise((resolve, reject) => {
      // Token requires only identifier & value — not full voucher data
      const payloadForToken = {
        identifier: cartBody.identifier,
        value: cartBody.value,
      };
      const encryptedPayload = encryptData(payloadForToken);

      $.ajax({
        url: "https://apis.arvindfashions.com/generate-token",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({ payload: encryptedPayload }),
        success: function (res) {
          if (res?.token) resolve(res.token);
          else reject("No token returned");
        },
        error: function (xhr, status, error) {
          console.error(
            "❌ Token generation failed:",
            xhr.responseText || error,
          );
          reject("Token generation failed: " + error);
        },
      });
    });
  }

  // -------------------------------
  // 🚀 Main Secure Flow
  // -------------------------------
  generateToken(discount_data)
    .then((apiToken) => {
      const encryptedBody = encryptData(discount_data);

      $.ajax({
        url: "https://apis.arvindfashions.com/api/voucher_create",
        method: "POST",
        contentType: "application/json",
        headers: { Authorization: `Bearer ${apiToken}` },
        data: JSON.stringify({ payload: encryptedBody }),
        success: function (response) {
          // ✅ Same behavior as old version
          discountUpdate("voucher", discount_data.code);
          $("#cstm_coupon_secc").show();
          // document.getElementById("input_field_loyalty").disabled = true;
          $("#cstm_coupon_err").hide();
          $("#coupon_btn_title .btntext").show();
          $("#coupon_btn_title svg").hide();
        },
        error: function (xhr, status, error) {
          console.error("❌ Error creating voucher:", error);
          $("#cstm_coupon_err")
            .show()
            .text("Failed to create voucher. Please try again.");
          $("#coupon_btn_title .btntext").show();
          $("#coupon_btn_title svg").hide();
        },
      });
    })
    .catch((err) => {
      console.error("❌ Voucher Token Error:", err);
      $("#cstm_coupon_err").show().text("Authentication failed. Please retry.");
      $("#coupon_btn_title .btntext").show();
      $("#coupon_btn_title svg").hide();
    });
}

function showApplyConflictError(type) {
  let message = "";
  if (type === "points") {
    message =
      "Voucher already applied. Please remove the voucher before applying points.";
  } else if (type === "voucher") {
    message =
      "Points already applied. Please remove the points before applying voucher.";
  }

  // Hide all old messages
  $("#errormessage, #cstm_coupon_err, #error-messagecart").hide();
  $(".successmessage, #pointremovedmsg, #vouchermovedmsg").hide();

  // Show contextual error
  if (type === "points") {
    $("#error-message").text(message).show();
  } else if (type === "voucher") {
    $("#cstm_coupon_err").text(message).show();
  }

  // Reset buttons if they were loading
  $("#redeemBtn, #coupon_btn_title").each(function () {
    $(this).find("svg").hide();
    $(this).find(".btntext").show();
    $(this).prop("disabled", false);
  });

  // Auto-hide error after few seconds
  setTimeout(() => {
    $("#error-message, #cstm_coupon_err").fadeOut();
  }, 4000);
}

// discountUpdate

function discountUpdate(type, code) {
  fetch("/cart.js")
    .then((res) => res.json())
    .then(async () => {
      if (type === "loyalty") {
        console.log(`Applying new discount code: ${code}`);
        await fetch(`/checkout?discount=${code}`);

        // stop spinner & swap buttons
        const $redeem = $("#redeemBtn");
        $redeem.find("svg").hide();
        $redeem.find(".btntext").show();

        $("#input_field_loyalty").attr("disabled", true);
        $("#redeemBtn").hide();
        $("#removeBtn").show();
        $(".successmessage").show();
        setTimeout(() => {
          $(".successmessage").hide();
        }, 5000);
        setTimeout(() => {
          $(".vouchermovedmsg").hide();
        }, 5000);

        // store applied points for any interval checker you run
        $("#appliedPoints").val(
          parseInt($("#input_field_loyalty").val(), 10) || 0,
        );
      } else if (type === "voucher") {
        console.log(`Removing discount code: ${code}`);
        await fetch(`/checkout?discount=${code}`);
        $("#input_field_coupon").attr("disabled", true);
        $("#coupon_btn_title").hide();
        $("#removeCoupon").show();
      }
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => checkCartThreshold(cart));

      cart_update();
    });
}

function cart_update(config) {
  fetch("/cart/update.js", { method: "POST" })
    .then((res) => res.json())
    .then(() => {
      fetch("/cart?view=ajax")
        .then((ress) => ress.text())
        .then((ress) => {
          const result = ress
            .replaceAll("<template", "<div")
            .replaceAll("template>", "div>");
          const element = document.createElement("div");
          element.insertAdjacentHTML("beforeend", result);

          const finalDetails = element.querySelector(
            ".ajax-cart__final-details",
          );
          const cartItems = element.querySelector(".ajax-cart__cart-items");

          if (finalDetails) {
            document.querySelector(
              "section .ajax-cart__final-details",
            ).innerHTML = finalDetails.innerHTML;
          }
          if (cartItems) {
            document.querySelector(".ajax-cart__cart-items").innerHTML =
              cartItems.innerHTML;
          }

          // --- FIX START ---
          lastServiceabilityHash = ""; // Force a refresh of the API data
          setTimeout(() => {
            initCartDelivery();
          }, 300); // Small delay to ensure DOM is painted
          // --- FIX END ---

          triggerServiceabilityRefresh();

          if (typeof Shopify?.theme?.ajaxCart?.cartEvents === "function") {
            Shopify.theme.ajaxCart.cartEvents(config);
          }
        });
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}

async function validateLoyaltyRedeem() {
  const inputField = document.getElementById("input_field_loyalty");
  const enteredValue = parseFloat(inputField.value.replace(/[^0-9]/g, "")) || 0;
  const cartSubtotal = await fetchCartSubtotal();
  if (enteredValue > cartSubtotal) {
    inputField.value = cartSubtotal;
  }
}

// customer should be redeem more the 50% of cart value
function getCartTotal() {
  return new Promise((resolve, reject) => {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => resolve(data.total_price / 100))
      .catch((error) => reject(error));
  });
}

let disableInterval;
let redeemBtnState = true;

// Self-healing protection (kept)
(function () {
  var FALLBACK_PARENT_SELECTOR = "#redeem-container";
  var btnRef = null,
    parentRef = null,
    templateHTML = "";

  function lockState(el) {
    el.id = "redeemBtn";
    if (redeemBtnState) {
      el.disabled = true;
      el.style.pointerEvents = "none";
      el.style.opacity = "0.5";
      el.style.cursor = "not-allowed";
      $(el).off("click");
    } else {
      el.disabled = false;
      el.style.pointerEvents = "auto";
      el.style.opacity = "1";
      el.style.cursor = "pointer";
      $(el)
        .off("click")
        .on("click", function () {
          console.log("Redeem clicked");
        });
    }
  }

  function ensureParent() {
    if (parentRef && document.body.contains(parentRef)) return parentRef;
    if (
      btnRef &&
      btnRef.parentElement &&
      document.body.contains(btnRef.parentElement)
    ) {
      parentRef = btnRef.parentElement;
      return parentRef;
    }
    parentRef =
      document.querySelector(FALLBACK_PARENT_SELECTOR) || document.body;
    return parentRef;
  }

  function recreateIfMissing() {
    if (!window.cartItemCount || window.cartItemCount === 0) return;

    var parent = ensureParent();
    parent.insertAdjacentHTML(
      "beforeend",
      templateHTML ||
        `
  `,
    );
    btnRef = parent.querySelector("#redeemBtn") || parent.lastElementChild;
    if (btnRef) lockState(btnRef);
  }

  function tick() {
    if (!btnRef) {
      btnRef = document.getElementById("redeemBtn");
      if (!btnRef) {
        recreateIfMissing();
        return;
      }
      if (!parentRef)
        parentRef =
          btnRef.parentElement ||
          document.querySelector(FALLBACK_PARENT_SELECTOR) ||
          document.body;
      if (!templateHTML) templateHTML = btnRef.outerHTML;
    }
    if (!document.contains(btnRef)) {
      recreateIfMissing();
      return;
    }
    lockState(btnRef);
  }

  function init() {
    btnRef = document.getElementById("redeemBtn") || null;
    if (btnRef) {
      parentRef = btnRef.parentElement;
      templateHTML = btnRef.outerHTML;
      lockState(btnRef);
    } else {
      parentRef =
        document.querySelector(FALLBACK_PARENT_SELECTOR) || document.body;
    }
    setInterval(tick, 120);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// 50% validation
async function checkValidAmount() {
  const cartTotal = await getCartTotal();
  const maxAmount = cartTotal * 0.5;
  const enteredAmount = parseInt(
    document.getElementById("input_field_loyalty").value,
    10,
  );

  if (enteredAmount > maxAmount) {
    $("#error-messagecart").show();
    startDisableLoop();
    $("#removeBtn").trigger("click");
  } else {
    $("#error-messagecart").hide();
    stopDisableLoop();
  }
  if (enteredAmount > 3000) {
    $("#error-messagecart").hide();
  }
}

function startDisableLoop() {
  redeemBtnState = true;
  if (!disableInterval) {
    disableInterval = setInterval(() => {
      $("#redeemBtn")
        .prop("disabled", true)
        .css({
          "pointer-events": "none",
          opacity: "0.5",
          cursor: "not-allowed",
        })
        .off("click");
    }, 100);
  }
}

function stopDisableLoop() {
  redeemBtnState = false;
  clearInterval(disableInterval);
  disableInterval = null;
  $("#redeemBtn")
    .prop("disabled", false)
    .css({
      "pointer-events": "auto",
      opacity: "1",
      cursor: "pointer",
    })
    .off("click")
    .on("click", function () {
      console.log("Redeem button clicked");
    });
}

$(function () {
  $("#input_field_loyalty").on("input", function () {
    var val = $(this).val().replace(/\D/g, "");
    $(this).val(val);

    if (val === "" || val === "0") {
      $("#error-message")
        .text(val === "0" ? "Enter valid amount" : "")
        .show();
      $("#redeemBtn")
        .prop("disabled", true)
        .css({
          "pointer-events": "none",
          opacity: "0.5",
          cursor: "not-allowed",
        })
        .off("click");
      $("#pointremovedmsg").hide();
    } else if (parseInt(val, 10) > 3000) {
      $("#error-message")
        .text("Maximum 3000 points can be redeemed per order")
        .show();
      $("#redeemBtn")
        .prop("disabled", true)
        .css({
          "pointer-events": "none",
          opacity: "0.5",
          cursor: "not-allowed",
        })
        .off("click");
      $("#pointremovedmsg").hide();
    } else {
      $("#error-message").hide();
      $("#redeemBtn")
        .prop("disabled", false)
        .css({
          "pointer-events": "",
          opacity: "",
          cursor: "",
        })
        .off("click"); // click bound on submit path
    }
  });
});

/**
 * ARVIND FASHIONS - CART DELIVERY SERVICEABILITY
 * Optimized to prevent infinite hits & work with AJAX Cart
 */

const STORAGE_KEY = "NNNOW_USER_LOCATION_DATA";
const PINCODE_JSON_URL = window.pincodeLookupJsonUrl;
let pincodeCache = null;

// State Management
let isCheckingServiceability = false;
let lastServiceabilityHash = ""; // Logic: Pincode + SKU List + Quantity List
let eddDebounceTimeout = null;
let invalidPincodeState = null;

// Iconslet invalidPincodeState = null;
const EX_ICON_SVG = `<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:8px;"><g clip-path="url(#clip0_262_1461)"><path d="M3.86637 7.99307L7.13136 11.7749L10.4007 7.94818C11.8768 6.22046 11.6645 3.25776 9.88412 1.71287C9.20574 1.12442 8.35244 0.673267 7.43914 0.669637L1.63527 0.646535C1.48358 0.645875 1.36675 0.671617 1.21066 0.653465L1.20312 0L7.39737 0.0283828C9.20166 0.0366337 10.7745 1.28845 11.5078 2.90264C12.3325 4.71815 12.1231 6.89043 10.8674 8.35776L7.12885 12.7271L3.61701 8.65116L1.20784 8.64389L1.20438 8.02475C1.3322 7.98977 1.45814 8.00165 1.59979 8.00132L3.86637 7.9934V7.99307Z" fill="#1D315B"/><path d="M4.45469 4.64356L1.20666 4.63828C1.19316 4.41716 1.19944 4.21683 1.2142 4.00495L5.45687 4.01386C5.70466 4.01452 5.9713 3.97492 6.19209 4.0363L7.12893 4.57921L8.87669 3.50924L7.46843 2.64489L3.1774 2.64291L3.18023 2.0165L7.64619 2.01914L9.80255 3.3231L9.79721 6.5802L7.12391 8.20066L4.54797 6.64092H2.52415L2.51819 6.01848L4.45218 6.01188L4.45469 4.6439V4.64356ZM7.43766 7.27129L9.19829 6.20627L9.19703 4.07261L7.54978 5.06205C7.43389 5.12475 7.42478 5.22607 7.42541 5.35182L7.43766 7.27129ZM6.81424 5.12541L5.99925 4.64092L5.0555 4.64951V6.21254L6.81833 7.27327L6.81424 5.12541Z" fill="#1D315B"/><path d="M8.62591 11.6591L9.059 11.1528C9.54863 11.3119 10.2154 11.8003 10.1899 12.4129C10.1588 13.1584 9.33161 13.5993 8.72955 13.7713C7.64478 14.0809 6.49657 14.0815 5.42153 13.7399C4.8333 13.5528 4.00543 13.0749 4.06887 12.3208C4.11818 11.7347 4.68663 11.3413 5.17971 11.1545C5.34176 11.3053 5.4743 11.4686 5.61594 11.6564C5.31318 11.7703 5.03116 11.8914 4.8066 12.1145C4.63575 12.2845 4.64172 12.5076 4.8044 12.6795C4.96709 12.8515 5.175 12.9601 5.39578 13.0535C5.96109 13.2927 6.54651 13.3502 7.15673 13.3498C7.80307 13.3495 8.42617 13.2706 9.01001 12.9828C9.19656 12.8908 9.36584 12.7891 9.49335 12.6231C9.85201 12.1574 8.97609 11.7686 8.62591 11.6591Z" fill="#1D315B"/><path d="M1.87558 2.0121L0 2.01485L0.000839315 2.64653L1.87642 2.64378L1.87558 2.0121Z" fill="#1D315B"/></g><defs><clipPath id="clip0_262_1461"><rect width="12" height="14" fill="white"/></clipPath></defs></svg>`;
const STD_ICON_SVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:8px;"><path d="M10.667 10.6667V2H0.666992V10.6667H10.667ZM10.667 10.6667H15.3337V7.33333L13.3337 5.33333H10.667V10.6667ZM5.33366 12.3333C5.33366 13.2538 4.58747 14 3.66699 14C2.74652 14 2.00033 13.2538 2.00033 12.3333C2.00033 11.4129 2.74652 10.6667 3.66699 10.6667C4.58747 10.6667 5.33366 11.4129 5.33366 12.3333ZM14.0003 12.3333C14.0003 13.2538 13.2541 14 12.3337 14C11.4132 14 10.667 13.2538 10.667 12.3333C10.667 11.4129 11.4132 10.6667 12.3337 10.6667C13.2541 10.6667 14.0003 11.4129 14.0003 12.3333Z" stroke="#1D315B" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

// --- UI Controls ---

function openEddModal() {
  const modal = document.getElementById("eddModal");
  if (!modal) return;

  const stored = localStorage.getItem(STORAGE_KEY);
  const input = document.getElementById("eddManualInput");
  if (stored && input) {
    try {
      const loc = JSON.parse(stored);
      input.value = loc.pincode || "";
    } catch (e) {
      /* ignore malformed storage */
    }
  }
  modal.style.display = "flex";
}

function closeEddModal() {
  const modal = document.getElementById("eddModal");
  if (modal) modal.style.display = "none";
}

function updateHeaderEligibility(allUnavailable) {
  const cityDisplay = document.getElementById("cart-city-val");
  const eligibleSuffix = document.getElementById("cart-eligible-suffix");

  if (allUnavailable) {
    // Same as PDP: show just the pincode, nothing after it.
    if (cityDisplay) cityDisplay.style.display = "none";
    if (eligibleSuffix) eligibleSuffix.style.display = "none";
  } else {
    if (cityDisplay) cityDisplay.style.display = "inline";
    if (eligibleSuffix) {
      eligibleSuffix.innerText = " is eligible for delivery services";
      eligibleSuffix.style.color = "";
      eligibleSuffix.style.display = "inline";
    }
  }
}

// --- Main Orchestrator ---

function initCartDelivery() {
  const cartItems = document.querySelectorAll(".ajax-cart__cart-item");
  const totalItems = window.cartItemCount || 0;

  if (cartItems.length === 0 && totalItems === 0) {
    const header = document.getElementById("cartDeliveryHeader");
    if (header) header.style.display = "none";
    return;
  }

  const header = document.getElementById("cartDeliveryHeader");
  const pinDisplay = document.getElementById("cart-pincode-val");
  const cityDisplay = document.getElementById("cart-city-val");
  const eligibleSuffix = document.getElementById("cart-eligible-suffix");

  if (!header) return;
  header.style.display = "block";

  if (invalidPincodeState) {
    if (pinDisplay && pinDisplay.innerText !== invalidPincodeState.pin) {
      pinDisplay.innerText = invalidPincodeState.pin;
    }
    if (cityDisplay && cityDisplay.innerText !== "") {
      cityDisplay.innerText = "";
    }
    if (eligibleSuffix) eligibleSuffix.style.display = "none";
    handleCartGlobalError(invalidPincodeState.message);
    return;
  }

  const storedLocation = localStorage.getItem(STORAGE_KEY);
  if (!storedLocation) {
    if (pinDisplay) pinDisplay.innerText = "Enter Pincode";
    if (cityDisplay) cityDisplay.innerText = "to check eligibility";
    if (eligibleSuffix) eligibleSuffix.style.display = "none";
    return;
  }

  const locationData = JSON.parse(storedLocation);
  if (cityDisplay) cityDisplay.style.display = "inline";
  if (eligibleSuffix) {
    eligibleSuffix.style.display = "inline";
    eligibleSuffix.innerText = " is eligible for delivery services";
    eligibleSuffix.style.color = "";
  }

  // FIX: Unique State Hash now includes Quantities
  const cartStateString = Array.from(cartItems)
    .map((item) => {
      const sku = item.getAttribute("data-sku") || "nosku";
      const qtyInput =
        item.querySelector("[data-item-qty]") ||
        item.querySelector(".ajax-cart__qty-input") ||
        item.querySelector('input[name="updates[]"]');
      const qty = qtyInput ? qtyInput.value : "1";
      return `${sku}:${qty}`;
    })
    .sort()
    .join("|");

  const currentHash = `${locationData.pincode}_${cartStateString}`;

  const cityName =
    locationData.city && locationData.city !== locationData.pincode
      ? locationData.city
      : "Home";

  if (pinDisplay) pinDisplay.innerText = locationData.pincode;
  if (cityDisplay) cityDisplay.innerText = cityName;

  // Trigger API if hash changed or state is fresh
  if (lastServiceabilityHash === currentHash && !isCheckingServiceability)
    return;

  lastServiceabilityHash = currentHash;
  runArvindServiceabilityAPI(locationData, cartItems);
}

// --- API Calls ---
async function runArvindServiceabilityAPI(locationData, cartItems) {
  if (isCheckingServiceability) return;

  // 1. Create a list of unique line items and their specific quantities.
  // Keep a reference to the exact DOM row so the response maps back to
  // this specific cart line item, not just "any row with this SKU".
  const skusToCheck = [];
  cartItems.forEach((item) => {
    const sku = item.getAttribute("data-sku");
    const qtyInput =
      item.querySelector("[data-item-qty]") ||
      item.querySelector(".ajax-cart__qty-input") ||
      item.querySelector('input[name="updates[]"]');
    const qty = qtyInput ? parseInt(qtyInput.value) : 1;

    if (sku && sku !== "null" && sku !== "") {
      skusToCheck.push({ sku, qty, element: item });
    }
  });

  if (skusToCheck.length === 0) return;
  isCheckingServiceability = true;

  // 2. Map through line items and create individual API promises
  // This forces the API to evaluate each item's hyperlocal eligibility independently
  const apiRequests = skusToCheck.map((item) => {
    const payload = {
      location: locationData.pincode.toString(),
      coordinates: {
        latitude: locationData.lat ? locationData.lat.toString() : "",
        longitude: locationData.lon ? locationData.lon.toString() : "",
      },
      storePickup: "",
      warehouseId: "clusterId",
      deliveryMode: ["standard", "sdd", "ndd", "hyperLocal"],
      items: [
        {
          skuId: item.sku,
          eoisSkuID: null,
          quantity: item.qty,
        },
      ],
    };

    return fetch(
      "https://apis.arvindfashions.com/api/order/details/check-serviceability",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          source: "SHOPIFY_USPA",
        },
        body: JSON.stringify(payload),
      },
    )
      .then((res) => res.json())
      .then((json) => ({ json, element: item.element }));
  });

  try {
    // 3. Fire all requests in parallel for maximum speed
    const results = await Promise.all(apiRequests);

    // 4. Consolidate the individual responses into one array for the UI renderer,
    // tagging each returned item with the exact cart row it came from.
    const consolidatedItems = [];
    results.forEach(({ json, element }) => {
      if (json.status && json.data && json.data.items) {
        json.data.items.forEach((apiItem) => {
          consolidatedItems.push({ ...apiItem, __element: element });
        });
      }
    });

    if (consolidatedItems.length > 0) {
      renderCartItemDeliveryUI(consolidatedItems);
    }
  } catch (e) {
    console.error("Individual Delivery API Fail:", e);
  } finally {
    isCheckingServiceability = false;
  }
}
window.isSyncingDeliveryData = false;
window.lastProcessedHash = "";

/**
 * 1. Core Logic: Processes API response and determines the best mode PER SKU
 */
function renderCartItemDeliveryUI(apiItems) {
  const pincode =
    document.getElementById("cart-pincode-val")?.innerText?.trim() || "";
  const storedLoc = JSON.parse(
    localStorage.getItem("NNNOW_USER_LOCATION_DATA") || "{}",
  );
  const lat = storedLoc.lat || "";
  const lon = storedLoc.lon || "";

  const itemModeMap = {};
  let cartHasHyperlocal = false;
  let cartHasSdd = false;
  let cartErrorCount = 0;

  apiItems.forEach((apiItem) => {
    const sku = apiItem.skuId;
    const modes = apiItem.deliverymodes || [];

    // Prefer the exact row this response came from. Fall back to a
    // SKU-based lookup only if for some reason the element wasn't carried
    // through (shouldn't happen in the normal flow).
    const itemRows = apiItem.__element
      ? [apiItem.__element]
      : document.querySelectorAll(`.ajax-cart__cart-item[data-sku="${sku}"]`);

    // Error case: API returned no deliverymodes / an explicit error message.
    // Don't set itemModeMap[sku] here — that's what keeps this line item out
    // of the Shopify cart-attribute sync below.
    const isErrorResponse =
      !apiItem.deliverymodes ||
      (typeof apiItem.message === "string" &&
        apiItem.message.toLowerCase().startsWith("error"));

    if (isErrorResponse) {
      cartErrorCount++;
      const errorMsg = "We do not offer shipping to this pincode currently";

      itemRows.forEach((itemRow) => {
        const oldTags = itemRow.querySelectorAll(".cart-item-edd-status");
        oldTags.forEach((t) => t.remove());

        const statusDiv = document.createElement("div");
        statusDiv.className = "cart-item-edd-status";
        statusDiv.style.cssText =
          "margin-top:10px; color:#d93025; font-size:12px; font-weight:700;";
        statusDiv.innerText = errorMsg;

        const targetContainer =
          itemRow.querySelector(".ajax-cart__item-details") || itemRow;
        targetContainer.appendChild(statusDiv);
      });

      return; // skip normal mode logic + itemModeMap assignment for this line item
    }

    // Priority Logic: Check availability for this specific SKU
    const hasHyperlocal = modes.some(
      (m) => m.deliveryType.toLowerCase() === "hyperlocal",
    );
    const hasSdd = modes.some((m) => m.deliveryType.toLowerCase() === "sdd");
    const hasNdd = modes.some((m) => m.deliveryType.toLowerCase() === "ndd");

    let itemBestMode = "standard";
    if (hasHyperlocal) {
      itemBestMode = "hyperlocal";
      cartHasHyperlocal = true;
    } else if (hasSdd) {
      itemBestMode = "sdd";
      cartHasSdd = true;
    } else if (hasNdd) {
      itemBestMode = "ndd";
    }

    itemModeMap[sku] = itemBestMode;

    // Render UI Tags for this exact row
    itemRows.forEach((itemRow) => {
      const oldTags = itemRow.querySelectorAll(".cart-item-edd-status");
      oldTags.forEach((t) => t.remove());

      const statusDiv = document.createElement("div");
      statusDiv.className = "cart-item-edd-status";
      statusDiv.style.cssText =
        "margin-top:10px; display:flex; align-items:center; color:#1D315B; font-size:13px; font-weight:500;";

      if (hasHyperlocal || hasSdd) {
        statusDiv.innerHTML = `${EX_ICON_SVG}<span>Available for 2 hour delivery</span>`;
      } else {
        const std = modes.find(
          (m) => m.deliveryType.toLowerCase() === "standard",
        );
        const dateStr = std?.deliveryDate
          ? std.deliveryDate.split(" ")[0]
          : "soon";
        statusDiv.innerHTML = `${STD_ICON_SVG}<span>Standard delivery by ${dateStr}</span>`;
      }
      const targetContainer =
        itemRow.querySelector(".ajax-cart__item-details") || itemRow;
      targetContainer.appendChild(statusDiv);
    });
  });

  // Only hide the header's city/suffix (PDP-style, pincode-only) when EVERY
  // item in the cart failed serviceability. If at least one line item is
  // deliverable, keep the normal "eligible" header messaging.
  updateHeaderEligibility(
    apiItems.length > 0 && cartErrorCount === apiItems.length,
  );

  // Overall cart delivery classification
  const overallFastest = cartHasHyperlocal
    ? "hyperlocal"
    : cartHasSdd
      ? "sdd"
      : "standard";
  const currentStatusHash = `${pincode}_${JSON.stringify(itemModeMap)}_${lat}_${lon}`;

  if (window.lastProcessedHash !== currentStatusHash) {
    syncDeliveryToOmuni(
      itemModeMap,
      overallFastest,
      pincode,
      lat,
      lon,
      currentStatusHash,
    );
  }
}

/**
 * 2. Shopify Sync: Updates Individual Line Item Properties
 */
async function syncDeliveryToOmuni(
  itemModeMap,
  overallFastest,
  pincode,
  lat,
  lon,
  hash,
) {
  if (window.isSyncingDeliveryData) return;
  if (!pincode || pincode.toLowerCase().includes("pincode")) return;

  window.isSyncingDeliveryData = true;

  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    // Map line items to their required delivery types
    const updatesNeeded = cart.items
      .map((item, index) => {
        const targetMode = itemModeMap[item.sku];
        if (!targetMode) return null;
        const currentMode = (item.properties || {})["Delivery Type"];
        return currentMode !== targetMode
          ? { line: index + 1, mode: targetMode, currentProps: item.properties }
          : null;
      })
      .filter((u) => u !== null);

    const needsAttrUpdate = cart.attributes["Delivery Type"] !== overallFastest;

    if (updatesNeeded.length === 0 && !needsAttrUpdate) {
      window.lastProcessedHash = hash;
      window.isSyncingDeliveryData = false;
      return;
    }

    // Update global attributes
    if (needsAttrUpdate) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            "Delivery Type": overallFastest,
            _pincode: pincode,
          },
        }),
      });
    }

    // Update individual line items
    for (const update of updatesNeeded) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: update.line,
          properties: { ...update.currentProps, "Delivery Type": update.mode },
        }),
      });
    }

    window.lastProcessedHash = hash;
  } catch (err) {
    console.error("Sync Error:", err);
  } finally {
    setTimeout(() => {
      window.isSyncingDeliveryData = false;
    }, 1000);
  }
}

// --- Geocoding Logic ---

/**
 * Executes pincode lookup to get Lat/Lon before saving
 */
async function processLocationChange(pin, locationFromDropdown = null) {
  closeEddModal();
  const pinDisplay = document.getElementById("cart-pincode-val");
  const cityDisplay = document.getElementById("cart-city-val");
  const eligibleSuffix = document.getElementById("cart-eligible-suffix");

  if (pinDisplay) pinDisplay.innerText = "Validating...";

  try {
    // 1. Load the JSON if not already cached
    if (!pincodeCache) {
      const response = await fetch(PINCODE_JSON_URL);
      pincodeCache = await response.json();
    }

    // 2. Lookup the pincode in your JSON database
    const pinData = pincodeCache[pin];

    if (pinData) {
      // ✅ CASE: Pincode exists in JSON
      invalidPincodeState = null; // clear any previous error state

      const lat = pinData.lat;
      const lon = pinData.lng;

      let finalLocation = locationFromDropdown;
      if (!finalLocation) {
        finalLocation = `${pinData.district || ""}, ${pinData.state || ""}`
          .trim()
          .replace(/^,/, "");
      }

      const dataToStore = {
        pincode: pin,
        city: finalLocation,
        lat: lat,
        lon: lon,
        timestamp: Date.now(),
      };

      // Save to LocalStorage ONLY on success
      localStorage.setItem(STORAGE_KEY, JSON.stringify(dataToStore));

      // Trigger API and UI update
      lastServiceabilityHash = "";
      initCartDelivery();
    } else {
      // ❌ CASE: Pincode NOT found in JSON
      const errorMsg = "We do not offer shipping to this pincode currently";
      invalidPincodeState = { pin, message: errorMsg }; // persist the bad pincode + message

      if (pinDisplay) pinDisplay.innerText = pin;
      if (cityDisplay) cityDisplay.innerText = "";
      if (eligibleSuffix) eligibleSuffix.style.display = "none";

      // IMPORTANT: We do NOT call localStorage.setItem here
      // IMPORTANT: We do NOT call initCartDelivery (skips the API)
      handleCartGlobalError(errorMsg);
    }
  } catch (e) {
    console.error("Pincode lookup error:", e);
    handleCartGlobalError("We do not offer shipping to this pincode currently");
  }
}

// 2. Helper to show error across all items in Cart
function handleCartGlobalError(msg) {
  // Clear item-level UI and show the custom error
  const cartItems = document.querySelectorAll(".ajax-cart__cart-item");

  cartItems.forEach((itemRow) => {
    // If this exact error is already showing on this row, do nothing.
    // Recreating the node every time is what restarts the fade-in
    // animation and makes it look like it's re-checking repeatedly.
    const existing = itemRow.querySelector(".cart-item-edd-status");
    if (existing && existing.dataset.errorMsg === msg) {
      return;
    }

    // Remove any existing status tags
    const oldTags = itemRow.querySelectorAll(".cart-item-edd-status");
    oldTags.forEach((t) => t.remove());

    // Create the error message element
    const statusDiv = document.createElement("div");
    statusDiv.className = "cart-item-edd-status";
    statusDiv.dataset.errorMsg = msg;
    statusDiv.style.cssText =
      "margin-top:10px; color:#d93025; font-size:12px; font-weight:500;";
    statusDiv.innerText = msg; // This will be your "We Do not offer..." message

    const targetContainer =
      itemRow.querySelector(".ajax-cart__item-details") || itemRow;
    targetContainer.appendChild(statusDiv);
  });

  // Reset the "Validating..." text if it's stuck
  const pinDisplay = document.getElementById("cart-pincode-val");
  if (pinDisplay && pinDisplay.innerText === "Validating...") {
    pinDisplay.innerText = "Invalid Pincode";
  }
}

// --- Handlers ---

async function useSavedAddress(el) {
  if (!el.value) return;
  const pin = el.value;
  const city = el.options[el.selectedIndex].dataset.city;
  processLocationChange(pin, city);
}

async function executePincodeCheck() {
  const rawPin = document.getElementById("eddManualInput").value;
  const pin = rawPin.trim();
  if (pin.length !== 6 || isNaN(pin))
    return alert("Please enter a valid 6-digit pincode");
  processLocationChange(pin);
}

function detectLiveLocation() {
  if (!navigator.geolocation) return alert("GPS not supported by your browser");
  const label = document.querySelector(".gps-info span");
  label.innerText = "Accessing GPS...";

  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      const { latitude, longitude } = pos.coords;
      try {
        // Note: We still need a quick reverse-geocode to get the Pincode NUMBER
        // from the GPS coordinates so we can look it up in your JSON.
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
        );
        const data = await res.json();
        const pin = data.address.postcode
          ? data.address.postcode.replace(/\s/g, "")
          : null;

        if (pin) {
          // Pass the detected pin to our local JSON processor
          processLocationChange(pin);
        } else {
          alert("Could not detect a valid pincode for this location.");
        }
      } catch (e) {
        alert("Location detection failed. Please enter pincode manually.");
      }
    },
    (err) => {
      alert("Location access denied. Please enter your pincode manually.");
    },
  );
}

// --- AJAX Watchers ---

const cartObserver = new MutationObserver((mutations) => {
  let shouldTrigger = false;

  for (let mutation of mutations) {
    const isOwnStatusNode = (n) =>
      n.nodeType === 1 &&
      n.classList &&
      n.classList.contains("cart-item-edd-status");

    const addedNodesList = Array.from(mutation.addedNodes);
    const removedNodesList = Array.from(mutation.removedNodes);

    const addedAreOwn =
      addedNodesList.length > 0 && addedNodesList.every(isOwnStatusNode);
    const removedAreOwn =
      removedNodesList.length > 0 && removedNodesList.every(isOwnStatusNode);

    const hasRealAdd = addedNodesList.length > 0 && !addedAreOwn;
    const hasRealRemove = removedNodesList.length > 0 && !removedAreOwn;

    if (hasRealAdd || hasRealRemove) {
      shouldTrigger = true;
      break;
    }
  }

  if (shouldTrigger) {
    // Debounce to prevent multiple hits during rapid updates
    clearTimeout(window.eddDebounceTimeout);
    window.eddDebounceTimeout = setTimeout(() => {
      initCartDelivery();
    }, 800);
  }
});

function startEddObserver() {
  // Target the main cart container or the body
  const target =
    document.querySelector(".cart-page") ||
    document.querySelector(".ajax-cart__cart-items") ||
    document.body;
  if (target) {
    cartObserver.observe(target, { childList: true, subtree: true });
  }
  // Initial check on page load
  initCartDelivery();
}

// Initialize on load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startEddObserver);
} else {
  startEddObserver();
}

function startEddObserver() {
  const target = document.querySelector(".cart-page") || document.body;
  if (target) cartObserver.observe(target, { childList: true, subtree: true });
  initCartDelivery();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startEddObserver);
} else {
  startEddObserver();
}

// Global hook for manual cart updates (+/- buttons)
const originalUpdate = window.cart_update;
if (typeof originalUpdate === "function") {
  window.cart_update = function (config) {
    originalUpdate(config);
    lastServiceabilityHash = ""; // Reset to force API hit
    setTimeout(initCartDelivery, 600);
  };
}

// On Startup
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startEddObserver);
} else {
  startEddObserver();
}

document.addEventListener("cart:updated", function (evt) {
  lastServiceabilityHash = "";
  setTimeout(initCartDelivery, 500);
});

// If your theme uses the standard 'theme-scripts'
$(document).on("ajaxCart.afterCartUpdate", function () {
  lastServiceabilityHash = "";
  setTimeout(initCartDelivery, 500);
});

function triggerServiceabilityRefresh() {
  console.log("🔄 Cart change detected: Re-validating serviceability...");

  // 0. A genuine cart change (qty/add/remove) should clear any stale pincode error
  invalidPincodeState = null;

  // 1. Reset the hash to force the API to recognize a "new" state
  window.lastServiceabilityHash = "";
  window.lastProcessedHash = "";
  window.isCheckingServiceability = false;

  // 2. Small delay to ensure the Theme/Shopify has finished DOM updates
  setTimeout(() => {
    initCartDelivery();
  }, 500);
}

// --- Global AJAX Interceptor ---
// This catches any theme-level fetch calls to Shopify's cart API (Add, Change, Update)
const originalFetch = window.fetch;
window.fetch = function () {
  return originalFetch.apply(this, arguments).then(async (response) => {
    const url = arguments[0];
    if (
      typeof url === "string" &&
      (url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear"))
    ) {
      triggerServiceabilityRefresh();
    }
    return response;
  });
};

// 1. Watch for Variant Selector changes specifically
$(document).on("change", ".variant-selector", function () {
  triggerServiceabilityRefresh();
});

// 2. Watch for Quantity button clicks
$(document).on(
  "click",
  ".ajax-cart__qty-control--up, .ajax-cart__qty-control--down",
  function () {
    triggerServiceabilityRefresh();
  },
);

// 3. Listen for the standard Shopify Cart update event
document.addEventListener("cart:updated", function () {
  triggerServiceabilityRefresh();
});

// 4. Hook into your theme's specific AJAX callback
$(document).on("ajaxCart.afterCartUpdate", function () {
  triggerServiceabilityRefresh();
});

// ////// REMOVE WHILE GOING TO PRODUCTION , FOR HYPERLOCAL TESTING PURPOSE ////////////////////

// // Step 1: Override fetch FIRST before anything fires
// const originalFetch = window.fetch;
// window.fetch = function(url, options) {
//     if (url && url.includes('check-serviceability') && options?.body) {
//         console.log("📤 Serviceability payload:", JSON.parse(options.body));
//     }
//     return originalFetch.apply(this, arguments);
// };

// // Step 2: Override location with Postman coordinates
// localStorage.setItem('NNNOW_USER_LOCATION_DATA', JSON.stringify({
//     pincode: "560068",
//     city: "Bangalore",
//     lat: "12.52319",
//     lon: "77.38178",
//     timestamp: Date.now()
// }));

// // Step 3: Reset hash to force API hit
// lastServiceabilityHash = "";

// // Step 4: Trigger delivery check
// initCartDelivery();

// ////// REMOVE WHILE GOING TO PRODUCTION , FOR HYPERLOCAL TESTING PURPOSE ////////////////////
